import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import AppFooter from './components/AppFooter';
import AppNavbar from './components/AppNavbar';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import DashboardPage from './pages/DashboardPage';
import DashboardRegistrationsPage from './pages/DashboardRegistrationsPage';
import AdminPendingRegistrationsPage from './pages/AdminPendingRegistrationsPage';
import AdminPlayersPage from './pages/AdminPlayersPage';
import AboutPage from './pages/AboutPage';
import ContactUsPage from './pages/ContactUsPage';
import EventDetailsPage from './pages/EventDetailsPage';
import EventsPage from './pages/EventsPage';
import JerseysPage from './pages/JerseysPage';
import HomePage from './pages/HomePage';
import IDCardsPage from './pages/IDCardsPage';
import AuthPage from './pages/AuthPage';
import RegisterPage from './pages/RegisterPage';
import PaymentPage from './pages/PaymentPage';
import PlayersPage from './pages/PlayersPage';
import PlayerProfilePage from './pages/PlayerProfilePage';
import ServiceCategoryPage from './pages/ServiceCategoryPage';
import ChangePassword from './components/ChangePassword';
import EditProfilePage from './pages/EditProfilePage';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminProductFormPage from './pages/AdminProductFormPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';
import AdminNoticesPage from './pages/AdminNoticesPage';
import AdminEventsPage from './pages/AdminEventsPage';
import GalleryPage from './pages/GalleryPage';
import AdminGalleryPage from './pages/AdminGalleryPage';
import AdminProgramsPage from './pages/AdminProgramsPage';

const App: React.FC = () => {
  return (
  <div className="app-shell">
    <AppNavbar />
    <main className="content-wrap">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/jerseys" element={<JerseysPage />} />
        <Route path="/services/:serviceSlug" element={<ServiceCategoryPage />} />
        <Route path="/players" element={<PlayersPage />} />
        <Route path="/players/:playerId" element={<PlayerProfilePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/registrations"
          element={
            <ProtectedRoute>
              <DashboardRegistrationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/idcards"
          element={
            <ProtectedRoute>
              <IDCardsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/profile/edit"
          element={
            <ProtectedRoute>
              <EditProfilePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/pending-registrations"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminPendingRegistrationsPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/players"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminPlayersPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/products"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminProductsPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/products/new"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminProductFormPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/products/:id/edit"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminProductFormPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/categories"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminCategoriesPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/admin/programs"
          element={
            <ProtectedRoute>
              <AdminRoute>
                <AdminProgramsPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
          <Route
            path="/dashboard/admin/notices"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <AdminNoticesPage />
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/admin/events"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <AdminEventsPage />
                </AdminRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/admin/gallery"
            element={
              <ProtectedRoute>
                <AdminRoute>
                  <AdminGalleryPage />
              </AdminRoute>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
    <AppFooter />
  </div>
);
};

export default App;
